const doc = [({"en":({"js":({"feedback_steps":({"give_feedback_here":"Here you give feedback on other people's answers"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;